import {
  getActionNameWithStatus,
  getResetAction,
} from "../../constants/actions-methods";
import { requestStatus } from "../../constants/request";
import { serverApis } from "../../constants/server-apis";

export const attachmentTypeListReducer = (state = [], action) => {
  const actionName = serverApis.getAttachmentTypeList.actionName;
  switch (action.type) {
    case getActionNameWithStatus(actionName, requestStatus.SUCCESS):
      return action.json.types;

    case getResetAction(actionName):
      return [];
    default:
      return state;
  }
};
